import makeStyles from '@mui/styles/makeStyles'
import { MyAccountTheme, SignupClasses } from '@dxp-module/themes'

const signupStyles = makeStyles<MyAccountTheme, object, SignupClasses>(
  ({ breakpoints }) => ({
    root: {
      padding: '60px',
      [breakpoints.down('sm')]: {
        margin: '10px',
      },
      [breakpoints.down('md')]: {
        padding: 0,
        margin: 0,
      },
    },
    cardContent: {
      '& .error-detail': {
        display: 'none',
      },
    },
    form: {},
    paper: {},
  }),
  { name: 'MyAccount_Signup' }
)

export default signupStyles
